import { render } from "./SupplierView.vue?vue&type=template&id=b7ed6406&scoped=true"
import script from "./SupplierView.vue?vue&type=script&lang=js"
export * from "./SupplierView.vue?vue&type=script&lang=js"

import "./SupplierView.vue?vue&type=style&index=0&id=b7ed6406&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ed6406"]])

export default __exports__